export enum ContactUs {
    ProductComplaints = 'Product Complaints',
    ServiceAndSupport = 'Service And Support',
    OrderEnquiries = 'Order Enquiries',
    DealerEnquiries = 'Dealer Enquiries',
    BulkDiscountEnquiries = 'Bulk Discount Enquiries'
}
